module.exports = __webpack_public_path__ + "static/media/26UNRWA19.985f8a70.jpg";